import { render, staticRenderFns } from "./TypesList.vue?vue&type=template&id=728a58b9&scoped=true&"
import script from "./TypesList.vue?vue&type=script&lang=js&"
export * from "./TypesList.vue?vue&type=script&lang=js&"
import style0 from "./TypesList.vue?vue&type=style&index=0&id=728a58b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a58b9",
  null
  
)

export default component.exports